import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

// NOTE: Fetch tasker profiles
export const fetchTaskerProfiles = createAsyncThunk(
  "client/fetch/taskerProfiles",
  async (arg) => {
    const query = generateQueryParams(arg);
    const response = await api.get(`user/tasker?${query}`);
    // delay for testing
    // await new Promise((resolve) => setTimeout(resolve, 5000));
    return response.data;
  }
);

// NOTE: Get Tasker Details
export const getTaskerDetails = createAsyncThunk(
  "auth/get/tasker/details",
  async (userId) => {
    const response = await api.get(`user/tasker?limit=1&userId=${userId}&withReviewedOrdersCount=true&withTotalOrdersCount=true`);
    // await new Promise((resolve) => setTimeout(resolve, 3000));
    return response.data;
  }
);

// NOTE: Get User Profile
export const getUserProfile = createAsyncThunk(
  "auth/get/user/profile",
  async () => {
    const response = await api.get("user/self");
    // delay for testing
    // await new Promise((resolve) => setTimeout(resolve, 3000));
    return response.data;
  }
);

// NOTE: Contact Us
export const contactUs = createAsyncThunk("/user/inquiry", async (data) => {
  const response = await api.post("user/inquiry", data);
  return response.data;
});

// Check-Email
export const checkEmail = createAsyncThunk("auth/check-email", async (email) => {
  const response = await api.post("auth/check-email", { email });
  return response.data;
});
